import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50/95 text-foreground-800 backdrop-blur transition-colors hover:border-primary-400 hover:bg-primary-500 hover:text-background-50 md:bottom-8 md:right-8"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}